const About = () => {
    return (
        <section id="about" className="py-20 bg-white dark:bg-gray-900">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">About Me</h2>
                    <div className="w-24 h-1 bg-blue-600 mx-auto rounded"></div>
                </div>

                <div className="flex flex-col md:flex-row items-center gap-12">
                    <div className="w-full md:w-1/2">
                        <div className="relative">
                            <div className="absolute -inset-2 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg blur opacity-20"></div>
                            <div className="relative bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl">
                                <h3 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Who I Am</h3>
                                <p className="text-gray-700 dark:text-gray-300 mb-4">
                                    I'm a cybersecurity analyst and developer with a passion for creating secure, efficient solutions.
                                    With expertise in vulnerability assessment, penetration testing, and secure coding practices,
                                    I help organizations protect their digital assets.
                                </p>
                                <p className="text-gray-700 dark:text-gray-300">
                                    When I'm not securing systems or writing code, I share my knowledge through my blog and
                                    contribute to open-source security projects. I believe in making cybersecurity knowledge
                                    accessible to everyone.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="w-full md:w-1/2">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                                <div className="text-blue-600 mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                    </svg>
                                </div>
                                <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Security Focus</h4>
                                <p className="text-gray-700 dark:text-gray-300">Specialized in application security, network defense, and security automation.</p>
                            </div>

                            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                                <div className="text-blue-600 mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                                    </svg>
                                </div>
                                <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Development</h4>
                                <p className="text-gray-700 dark:text-gray-300">Building secure applications with modern frameworks and best practices.</p>
                            </div>

                            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                                <div className="text-blue-600 mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.414 2.414l-5-5a2 2 0 00-1.414-.586H6.414a2 2 0 00-1.414.586l-5 5c-1.781 1-2.674-1.154-1.414-2.414l5-5A2 2 0 005.172 10H5.5V5a1.5 1.5 0 011.5-1.5z" />
                                    </svg>
                                </div>
                                <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Research</h4>
                                <p className="text-gray-700 dark:text-gray-300">Exploring emerging threats and security methodologies to stay ahead.</p>
                            </div>

                            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                                <div className="text-blue-600 mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                    </svg>
                                </div>
                                <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Knowledge Sharing</h4>
                                <p className="text-gray-700 dark:text-gray-300">Committed to educating others through blogging and open source contributions.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-16 flex justify-center">
                    <a
                        href="#skills"
                        className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors shadow-lg hover:shadow-xl"
                    >
                        Explore My Skills
                    </a>
                </div>
            </div>
        </section>
    );
};

export default About;